import React, { useState, useEffect } from "react"
import "@/assets/scss/app/header.scss"

//modules
import Messages from "./modules/Messages"
import Employees from "./modules/Employees"

import { useAuthDataContext } from "../../_providers/Auth"

//images
import brand from "../../assets/img/header/brand.png"

import mail from "../../assets/img/header/icons/mail.png"
import settings from "../../assets/img/header/icons/settings.png"
import profile from "../../assets/img/header/icons/profile.png"
import hamburger from "../../assets/img/header/menu.png"
import { useNotificationsContext } from "../../_providers/Notifications"
import { useMessagesContext } from "../../_providers/Messages"
import { useHistory } from "react-router-dom"
import { trans } from "../../_providers/Translation"
import workGuideIcon from "../../assets/img/header/icons/work-guide.svg"

// components
import NotificationsInHeader from "@/components/app/partials/NotificationsInHeader"
import ChatInHeader from "@/components/app/partials/ChatInHeader"
import UserInHeader from "@/components/app/partials/UserInHeader"
import GlobalSearch from "./partials/GlobalSearch"

function Header() {
  const auth = useAuthDataContext()
  const messages = useMessagesContext()

  const history = useHistory()

  const handleLogout = () => auth.logout()

  const handleMobileMenu = (e) => {
    e.stopPropagation()
    document.querySelector("aside").classList.add("visable-aside")
    document.querySelector("body").classList.add("blured-content")
  }

  const handleShowSettings = () => {
    history.push("/profile/settings")
  }

  useEffect(() => {
    const handlePageClick = () => {
      const menu = document.querySelector("aside")

      if (menu && menu.classList.contains("visable-aside")) {
        menu.classList.remove("visable-aside")
        document.querySelector("body").classList.remove("blured-content")
      }
    }

    document.addEventListener("click", handlePageClick)
    return () => document.removeEventListener("click", handlePageClick)
  }, [])

  return (
    <header>
      <div className="wrapper">
        <div className="left">
          <div className="hamburger" onClick={handleMobileMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <GlobalSearch />
        </div>
        <div className="right">
          <ul>
            <li style={{ marginRight: 5 }}>
              <a
                href="https://website.eus.tech/tutorials/dashboard"
                className="button-add button-small"
                target="_blank"
                rel="noreferrer"
              >
                <img src={workGuideIcon} alt="work guide" />
                {trans("header.workGuide")}
              </a>
            </li>
            <li className="user-li">
              <UserInHeader />
            </li>
            {auth.access("livechat") ? (
              <li className="chat-li">
                <ChatInHeader />
              </li>
            ) : (
              <></>
            )}
            <li className="notifications-li">
              <NotificationsInHeader />
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}

export default Header
